import React, { ErrorInfo, ReactNode } from 'react';

import ErrorBoundaryFeature from './error-boundary-feature';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | string | null;
  errorInfo: ErrorInfo | null;
  currentLocation: string | undefined;
}

export class ErrorBoundaryMain extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorInfo: null, currentLocation: undefined };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
      currentLocation: window.location.href,
    });
    // Catch errors in any components below and re-render with error message
  }

  resetErrorBoundary = () => {
    this.setState({ error: null, errorInfo: null, currentLocation: undefined });
  };

  // Only enable if we're catching errors in the right environment
  isEnabled(): boolean {
    return import.meta.env.DEV || import.meta.env.PROD;
  }

  shouldComponentUpdate(
    nextProps: Readonly<Props>,
    nextState: Readonly<State>
  ): boolean {
    return nextState.error !== this.state.error;
  }

  /**
   *
   * @TODODEV : ajouter le message suivant "Unable to preload CSS for" aux conditions afin de faire location.relaod()
   */
  // Error: Unable to preload CSS for /assets/index-9903d4bb.css
  // at HTMLLinkElement.<anonymous> (https://crm.greenkub.fr/assets/index-99cd89ef.js:177:294321)
  render() {
    if (
      (typeof this.state.error === 'string' &&
        this.state.error.includes(
          'Failed to fetch dynamically imported module'
        )) ||
      (typeof this.state.error === 'object' &&
        this.state.error?.message &&
        this.state.error.message.includes(
          'Failed to fetch dynamically imported module'
        ))
    ) {
      location.reload();
      return;
    }

    if (this.isEnabled() && this.state.error) {
      return (
        <ErrorBoundaryFeature
          error={this.state.error as Error}
          currentLocation={window.location.href}
          resetErrorBoundary={this.resetErrorBoundary}
        />
      );
    }
    return this.props.children;
  }
}
